import React from "react";
import { FaBabyCarriage, FaChild, FaUser } from "react-icons/fa";

const formatBaggage = (value) => (value?.trim() ? value : "No Baggage");

function BaggageDetails({ segment, passengers = {} }) {
	const paxTypes = [
		{
			key: "adult",
			label: "Adult",
			icon: FaUser,
			present: passengers.adult > 0,
			checkin: segment?.checkinBaggage,
			cabin: segment?.cabinBaggage,
		},
		{
			key: "child",
			label: "Child",
			icon: FaChild,
			present: passengers.child > 0,
			checkin: segment?.childCheckinBaggage,
			cabin: segment?.childCabinBaggage,
		},
		{
			key: "infant",
			label: "Infant",
			icon: FaBabyCarriage,
			present: passengers.infant > 0,
			checkin: segment?.infantCheckinBaggage,
			cabin: segment?.infantCabinBaggage,
		},
	];

	return (
		<>
			<h6>Baggage Details</h6>
			{paxTypes
				.filter(({ present }) => present)
				.map(({ key, label, icon: Icon, checkin, cabin }) => (
					<div key={key} className="mt-2 align-center">
						<div className="w-8 h-8 mr-2 rounded-sm bg-light flex-center">
							<Icon />
						</div>
						<div>
							<h6>{label}</h6>
							<div className="text-xs text-secondary">Check in: {formatBaggage(checkin)}</div>
							<div className="text-xs text-secondary">Cabin: {formatBaggage(cabin)}</div>
						</div>
					</div>
				))}
		</>
	);
}

export default BaggageDetails;
